import {
  GET_CARRIER_CONFIGURATION_LIST_FAILURE,
  GET_CARRIER_CONFIGURATION_LIST_REQUEST,
  GET_CARRIER_CONFIGURATION_LIST_SUCCESS,
  ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE,
  ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST,
  ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS,
  GET_CARRIER_MILESTONE_LIST_REQUEST,
  GET_CARRIER_MILESTONE_LIST_FAILURE,
  GET_CARRIER_MILESTONE_LIST_SUCCESS,
  GET_MILESTONE_LOOKUP_REQUEST,
  GET_MILESTONE_LOOKUP_SUCCESS,
  GET_MILESTONE_LOOKUP_FAILURE,
  ADD_UPDATE_CARRIER_MILESTONE_REQUEST,
  ADD_UPDATE_CARRIER_MILESTONE_SUCCESS,
  ADD_UPDATE_CARRIER_MILESTONE_FAILURE,
  GET_CARRIER_ACTIVITY_LIST_FAILURE,
  GET_CARRIER_ACTIVITY_LIST_REQUEST,
  GET_CARRIER_ACTIVITY_LIST_SUCCESS,
  GET_CARRIER_CONFIGURATION_DETAILS_FAILURE,
  GET_CARRIER_CONFIGURATION_DETAILS_REQUEST,
  GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS,
} from "./actionTypes";
import {
  GetCarrierConfigurationListFailure,
  GetCarrierConfigurationListRequest,
  GetCarrierConfigurationListSuccess,
  CarrierConfigurationListSuccessPayload,
  AddUpdateCarrierConfigurationFailure,
  AddUpdateCarrierConfigurationRequest,
  AddUpdateCarrierConfigurationSuccess,
  AddUpdateCarrierConfigurationSuccessPayload,
  GetCarrierMilestoneListFailure,
  GetCarrierMilestoneListSuccess,
  GetCarrierMilestoneListRequest,
  CarrierMilestoneListSuccessPayload,
  GetMilestoneLookupRequest,
  MilestoneLookupListSuccessPayload,
  GetMilestoneLookupSuccess,
  GetMilestoneLookupFailure,
  AddUpdateCarrierMilestoneRequest,
  AddUpdateCarrierMilestoneSuccess,
  AddUpdateCarrierMilestoneFailure,
  GetCarrierActivityListRequest,
  GetCarrierActivityListSuccess,
  GetCarrierActivityListFailure,
  CarrierActivityListSuccessPayload,
  GetCarrierConfigurationDetailsFailure,
  GetCarrierConfigurationDetailsRequest,
  GetCarrierConfigurationDetailsSuccess,
  FailurePayload,
} from "./types";

export const getCarrierConfigurationListRequest = (
  url: string,
  payload: any,
): GetCarrierConfigurationListRequest => ({
  type: GET_CARRIER_CONFIGURATION_LIST_REQUEST,
  url,
  payload,
});

export const getCarrierConfigurationListSuccess = (
  payload: CarrierConfigurationListSuccessPayload,
): GetCarrierConfigurationListSuccess => ({
  type: GET_CARRIER_CONFIGURATION_LIST_SUCCESS,
  payload,
});

export const getCarrierConfigurationListFailure = (
  payload: FailurePayload,
): GetCarrierConfigurationListFailure => ({
  type: GET_CARRIER_CONFIGURATION_LIST_FAILURE,
  payload,
});

export const getCarrierConfigurationDetailsRequest = (
  url: string,
): GetCarrierConfigurationDetailsRequest => ({
  type: GET_CARRIER_CONFIGURATION_DETAILS_REQUEST,
  url,
});

export const getCarrierConfigurationDetailsSuccess = (
  payload: CarrierConfigurationListSuccessPayload,
): GetCarrierConfigurationDetailsSuccess => ({
  type: GET_CARRIER_CONFIGURATION_DETAILS_SUCCESS,
  payload,
});

export const getCarrierConfigurationDetailsFailure = (
  payload: FailurePayload,
): GetCarrierConfigurationDetailsFailure => ({
  type: GET_CARRIER_CONFIGURATION_DETAILS_FAILURE,
  payload,
});

export const addUpdateCarrierConfigurationRequest = (
  url: string,
  payload: any,
  callback: unknown,
): AddUpdateCarrierConfigurationRequest => ({
  type: ADD_UPDATE_CARRIER_CONFIGURATION_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCarrierConfigurationSuccess = (
  payload: AddUpdateCarrierConfigurationSuccessPayload,
): AddUpdateCarrierConfigurationSuccess => ({
  type: ADD_UPDATE_CARRIER_CONFIGURATION_SUCCESS,
  payload,
});

export const addUpdateCarrierConfigurationFailure = (
  payload: FailurePayload,
): AddUpdateCarrierConfigurationFailure => ({
  type: ADD_UPDATE_CARRIER_CONFIGURATION_FAILURE,
  payload,
});

export const getCarrierMilestoneRequest = (
  url: string,
  payload: any,
): GetCarrierMilestoneListRequest => ({
  type: GET_CARRIER_MILESTONE_LIST_REQUEST,
  url,
  payload,
});

export const getCarrierMilestoneListSuccess = (
  payload: CarrierMilestoneListSuccessPayload,
): GetCarrierMilestoneListSuccess => ({
  type: GET_CARRIER_MILESTONE_LIST_SUCCESS,
  payload,
});

export const getCarrierMilestoneListFailure = (
  payload: FailurePayload,
): GetCarrierMilestoneListFailure => ({
  type: GET_CARRIER_MILESTONE_LIST_FAILURE,
  payload,
});

export const getMilestoneLookupRequest = (
  url: string,
): GetMilestoneLookupRequest => ({
  type: GET_MILESTONE_LOOKUP_REQUEST,
  url,
});

export const getMilestoneLookupSuccess = (
  payload: MilestoneLookupListSuccessPayload,
): GetMilestoneLookupSuccess => ({
  type: GET_MILESTONE_LOOKUP_SUCCESS,
  payload,
});

export const getMilestoneLookupFailure = (
  payload: FailurePayload,
): GetMilestoneLookupFailure => ({
  type: GET_MILESTONE_LOOKUP_FAILURE,
  payload,
});

export const addUpdateCarrierMilestoneRequest = (
  url: string,
  payload: any,
  callback: unknown,
): AddUpdateCarrierMilestoneRequest => ({
  type: ADD_UPDATE_CARRIER_MILESTONE_REQUEST,
  url,
  payload,
  callback,
});

export const addUpdateCarrierMilestoneSuccess = (
  payload: AddUpdateCarrierConfigurationSuccessPayload,
): AddUpdateCarrierMilestoneSuccess => ({
  type: ADD_UPDATE_CARRIER_MILESTONE_SUCCESS,
  payload,
});

export const addUpdateCarrierMilestoneFailure = (
  payload: FailurePayload,
): AddUpdateCarrierMilestoneFailure => ({
  type: ADD_UPDATE_CARRIER_MILESTONE_FAILURE,
  payload,
});

export const getCarrierActivityListRequest = (
  url: string,
  payload: any,
): GetCarrierActivityListRequest => ({
  type: GET_CARRIER_ACTIVITY_LIST_REQUEST,
  url,
  payload,
});

export const getCarrierActivityListSuccess = (
  payload: CarrierActivityListSuccessPayload,
): GetCarrierActivityListSuccess => ({
  type: GET_CARRIER_ACTIVITY_LIST_SUCCESS,
  payload,
});

export const getCarrierActivityListFailure = (
  payload: FailurePayload,
): GetCarrierActivityListFailure => ({
  type: GET_CARRIER_ACTIVITY_LIST_FAILURE,
  payload,
});
